import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IInvestorsFeaturedBoxProps extends IBaseElementProps {
	/**
	 * If you turn this on, the box will automatically be filled with the most
	 * recent post, replacing whatever is entered below.
	 */
	useRecentPost?: boolean;
	/**
	 * Investors Featured Box Date
	 */
	date?: string;
	/**
	 * Investors Featured Box Heading
	 */
	heading?: string;
	/**
	 * Investors Featured Box Sub Heading
	 */
	subheading?: string;
	/**
	 * Investors Featured Text
	 * @control richtext
	 */
	text?: string;
	/**
	 * Investors Featured Box Link
	 */
	link?: ILink;
	backgroundStyle?: 'Gradient' | 'Solid';
}

/**
 * Investors Featured Box
 * @block
 * @icon star-filled
 */
const InvestorsFeaturedBox: React.FC<IInvestorsFeaturedBoxProps> = ({
	useRecentPost = false,
	date,
	heading,
	subheading,
	text,
	link,
	id,
	className,
	classNames = [],
	backgroundStyle = 'Gradient',
}) => (
	<div
		id={id}
		className={cn(
			'calian-investors-featured-box',
			`calian-investors-featured-box--${backgroundStyle.toLowerCase()}`,
			className,
			{
				'calian-investors-featured-box--text-only':
					!heading && !link?.label,
			},
		)}
	>
		{date && (
			<span className="calian-investors-featured-box__date">{date}</span>
		)}
		{heading && (
			<h4 className="calian-investors-featured-box__heading">
				{heading}
			</h4>
		)}
		{subheading && (
			<h5 className="calian-investors-featured-box__sub-heading mb-0 text-white">
				{subheading}
			</h5>
		)}
		{text && (
			<div
				className="calian-investors-featured-box__text"
				dangerouslySetInnerHTML={{
					__html: text,
				}}
			/>
		)}
		{link?.label && (
			<Button
				{...link}
				className="calian-investors-featured-box__button btn btn-sm btn-light"
			/>
		)}
	</div>
);

export default InvestorsFeaturedBox;
